export enum ESwitcherAssetType {
  Empty,
  Media,
  Gfx,
  Layout,
  Block,
  LiveFeed,
  Stack,
}
